import TecnicoService from "@/services/TecnicoService";

export const tecnico = {
  namespaced: true,
  state: {
    tecnico: {},
  },
  actions: {
    getTecnico({ commit }, payload) {
      return TecnicoService.GetTecnico(payload).then(
        (tecnico) => {
          return Promise.resolve(tecnico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTecnico({ commit }, payload) {
      return TecnicoService.PostTecnico(payload).then(
        (tecnico) => {
          return Promise.resolve(tecnico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTecnico({ commit }, payload) {
      return TecnicoService.PutTecnico(payload).then(
        (tecnico) => {
          return Promise.resolve(tecnico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTecnico({ commit }, payload) {
      return TecnicoService.DeleteTecnico(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTecnicoOData({ commit }, payload) {
      return TecnicoService.GetTecnicoOData(payload).then(
        (tecnico) => {
          return Promise.resolve(tecnico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tecnico;
